export enum PropertyDevelopmentType {
    NewConstruction = 0,
    Renovation = 1,
    RenovationAndExpansion = 2,
    NewAcquisition = 3,
    Other = 4,
}
